module.exports = __webpack_public_path__ + "static/media/vampire.102c4761.png";